// roleService.js

import axios from "axios";

class roleService {
  constructor() {
    this.API_URL = process.env.REACT_APP_API_URL_V; // Assuming you have defined your API URL properly
    this.apiClient = axios.create({
      baseURL: this.API_URL,
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    });

    this.apiClient.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem("accesstoken");
        config.headers["x-auth-token"] = token;
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }

  // Method to add a new role
  async addRole(roleData) {
    const response = await this.apiClient.post("/admins/roles", roleData);
    return response.data;
  }

  // Method to update an existing role
  async updateRole(roleId, roleData) {
    const response = await this.apiClient.put(
      `/admins/roles/${roleId}`,
      roleData
    );
    return response.data;
  }

}

export default new roleService();
